import Cookie from "js-cookie";
import Environment from "~/common/Environment";

export type Request = {
  brandId: number;
  categoryId: number;
  userId: number | null;
  sessionId: string | undefined;
  url: string;
};

export const defaultSessionId = "00000000-0000-0000-0000-000000000000";

export type RequestType = "click" | "impression";

const trackBrandLogoAdService = async (
  requestType: RequestType,
  request: Request
) => {
  if (request.sessionId === undefined) {
    request.sessionId = Cookie.get("CFID") ?? defaultSessionId;
  }

  try {
    await fetch(
      `https://${Environment.stashDomainWithEnvironment}/brandlogo/track/${requestType}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      }
    );
  } catch {
    // Do nothing
  }
};

export default trackBrandLogoAdService;
